import React, { useEffect } from "react";
import { useIntl } from "react-intl";

import { SearchModal } from "@housebets/housebets-x-package";

import { useGTMEvents } from "app/hooks/useGTMEvents";
import { useSearchGameModalData } from "./hooks/useSearchGameModalData";
import { getGameDetailUrl, getGameImageUrl } from "app/utils/help";
import { ISearchGameModalProps } from "./types";
import { ICardProps } from "@housebets/housebets-x-package/lib/components/cards/Card/types";
import { useLangNavigate } from "app/hooks/useLangNavigate";

const skeleton: ICardProps = {
    skeleton: true,
    type: "GAME_V2",
    src: "",
};

export const SearchGameModal: React.FC<ISearchGameModalProps> = ({
    isOpen,
    setIsOpen
}) => {
    const { $t } = useIntl();
    const { modal } = useGTMEvents();
    const {
        keyWord,
        setKeyWord,
        activeTagId,
        setActiveTagId,
        isLoading,
        navigationModalList,
        gameList,
        initData,
        getGameList,
        listMeta,
        onLoadMore,
        disposeData,
    } = useSearchGameModalData();
    const langNavigate = useLangNavigate();

    useEffect(() => {
        if (isOpen) {
            initData();
        } else {
            disposeData();
        }
    }, [isOpen]);

    return (
        <SearchModal
            text={{
                emptyListMsg: $t({ id: "NoResult" }),
                inputPlaceholder: $t({ id: "SearchByGameProvidersEtc" })
            }}
            navigationList={navigationModalList}
            onLinkChange={(v) => {
                if (v === activeTagId || isLoading) return;
                initData();
                setActiveTagId(v);
                getGameList(v);
            }}
            searchStr={keyWord}
            setSearchStr={setKeyWord}
            isLoading={isLoading}
            list={gameList.length === 0 && isLoading ? [
                skeleton, skeleton, skeleton, skeleton, skeleton, skeleton, skeleton, skeleton, skeleton, skeleton, skeleton, skeleton
            ] : gameList.map((item) => {
                const url = getGameDetailUrl(item, langNavigate);
                return {
                    ...item,
                    showPlaceholder: false,
                    imageLayers: {
                        mediaImage: getGameImageUrl(item).default,
                    },
                    optimizedSrc: getGameImageUrl(item).optimizedSrc,
                    id: item.gameId,
                    href: url,
                    type: "GAME_V2"
                }
            })}
            pagination={
                isLoading
                    ? null
                    : {
                        listMeta,
                        onLoadMore
                    }
            }
            isOpen={isOpen}
            onClose={() => {
                setIsOpen(false);
            }}
            afterOpenModal={() => {
                modal.show('search')
            }}
            onAfterClose={() => {
                modal.close('search')
            }}
        />
    )
}